import { observer } from 'mobx-react';
import { FC } from 'react';
import { useForm, withForm } from 'react-bootstrap-formutil';
import AccountCapability from 'components/forms/AccountCapability';
import AssetsInfo from 'components/forms/AssetsInfo';
import Checkbox from 'components/forms/Checkbox';
import EnhanceProgram, { openAgreementModal } from 'components/forms/EnhanceProgram';
import InvestInfo from 'components/forms/InvestInfo';
import OptAgreeCheckbox from 'components/forms/InvestInfo/OptAgreeCheckbox';
import InvestTarget from 'components/forms/InvestTarget';
import TradeType from 'components/forms/TradeType';
import { usePowerNavigate } from 'components/PowerNavigate';
import security from 'stores/security';
import values from 'stores/values';
import { AccountCapabilitiesEnum, CustomerInfoType } from 'types/customer';
import Container from '../components/Container';

const Invest: FC = () => {
    const navigate = usePowerNavigate();
    const {
        $params: { account_capabilities, opt_perm, category, age, enhance_perm }
    } = useForm<CustomerInfoType>();
    // opt_perm === '1'表示用户选择了期权交易项
    const isOption = opt_perm === '1'; // 是否有其他配置项

    const handleSubmit = () => {
        const temporaryConfirmFPSLAgreement = sessionStorage.getItem('temporaryConfirmFPSLAgreement') === '1';

        if (enhance_perm === '1' && !temporaryConfirmFPSLAgreement) {
            openAgreementModal().then((result: boolean) => {
                if (result) {
                    sessionStorage.setItem('temporaryConfirmFPSLAgreement', '1');

                    navigate('../summary');
                }
            });
        } else {
            navigate('../summary');
        }
    };

    return (
        <Container onSubmit={handleSubmit}>
            <h3 className="open-title mt-0">{__('INVEST INFORMATION')}</h3>
            <AccountCapability category={category} disabled />
            {account_capabilities === AccountCapabilitiesEnum.MARGIN && (
                <Checkbox
                    disabled
                    name="temporary_margin_check"
                    $defaultValue={true}
                    checker={value => !!value || __('请您阅读并同意上述协议')}
                    label={
                        <>
                            * {__('I have read the ')}
                            <a href="https://www.tradeup.com/agreement/178" target="_blank" data-inapp-blank>
                                {__('Margin Disclosure Statement')}
                            </a>
                            {__('and understand the risks')}
                        </>
                    }
                />
            )}
            <TradeType age={age} disabled />
            <AssetsInfo disabled />
            <InvestTarget disabled />
            {isOption && (
                <>
                    <h4 className="mt-4 mb-3">{__('Option Investment Experience')}</h4>
                    <InvestInfo name="opt" age={age} isOption minTradeYears={2} isMarsco disabled />
                    <OptAgreeCheckbox disabled />
                </>
            )}
            <EnhanceProgram disabled />
        </Container>
    );
};

export default withForm(observer(Invest), {
    $defaultValues: () => {
        values.setShowProgressBar(false);

        return security.customerInfo;
    }
});
